'use client';

import { useEffect, useState } from 'react';

interface AntiFluffStatementProps {
  language: 'en' | 'es';
}

const AntiFluffStatement = ({ language }: AntiFluffStatementProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const element = document.getElementById('anti-fluff');
    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const content = {
    en: 'No jargon. No surprise billing. No unnecessary meetings.',
    es: 'Sin jerga. Sin facturación sorpresa. Sin reuniones innecesarias.',
  };

  return (
    <section id="anti-fluff" className="py-20 px-6 bg-foreground">
      <div className="max-w-screen-xl mx-auto text-center">
        <p
          className={`text-3xl md:text-4xl font-bold text-background leading-tight ${
            isVisible ? 'animate-fadeInUp' : 'opacity-0'
          }`}
        >
          {content[language]}
        </p>
      </div>
    </section>
  );
};

export default AntiFluffStatement;